module.exports = __webpack_public_path__ + "static/media/o-home-title-img.edc1bb6a.svg";